import Nullstack from 'nullstack';
export default function IconDropletFilled({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-droplet-filled",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v17"
  }), "   ", Nullstack.element("path", {
    d: "M12 12l3.544 -3.544"
  }), "   ", Nullstack.element("path", {
    d: "M12 17.3l5.558 -5.558"
  }), " ");
}